export default {
  /****
     * json对象合并
     * @param des json对象
     * @param src json对象或者json数组
     * @param override 是否覆盖
     * @returns 合并后json对象
     */
  extend(des, src, override) {
    if (src instanceof Array) {
      for (var i = 0, len = src.length; i < len; i++) { this.extend(des, src[i], override); }
    }
    for (var key in src) {
      if (override || !(key in des)) {
        des[key] = src[key];
      }
    }
    return des;
  }
};
